export const Video = () => {
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 90 90" enableBackground="new 0 0 90 90" xmlSpace="preserve">
            <path fill="transparent" opacity="1.000000" stroke="none" 
                d="
            M57.000000,91.000000 
                C38.000004,91.000000 19.500006,91.000000 1.000007,91.000000 
                C1.000005,61.000008 1.000005,31.000017 1.000003,1.000020 
                C30.999985,1.000013 60.999969,1.000013 90.999969,1.000006 
                C90.999977,30.999979 90.999977,60.999958 90.999985,90.999969 
                C79.833336,91.000000 68.666664,91.000000 57.000000,91.000000 
            M32.782799,84.972656 
                C39.908096,87.073746 47.005894,87.588989 54.426319,86.083893 
                C72.147873,82.489388 85.251015,68.009499 86.862129,49.929691 
                C88.028191,36.844204 83.795631,25.490459 73.827446,16.154299 
                C60.247292,3.435177 42.248619,1.628694 27.130920,9.618878 
                C11.906135,17.665661 1.816696,34.613064 5.898071,53.745258 
                C9.138709,68.936333 17.776888,79.020607 32.782799,84.972656 
            z"/>
            <path fill="#FFFDFE" opacity="1.000000" stroke="none" 
                d="
            M32.421631,84.775581 
                C17.776888,79.020607 9.138709,68.936333 5.898071,53.745258 
                C1.816696,34.613064 11.906135,17.665661 27.130920,9.618878 
                C42.248619,1.628694 60.247292,3.435177 73.827446,16.154299 
                C83.795631,25.490459 88.028191,36.844204 86.862129,49.929691 
                C85.251015,68.009499 72.147873,82.489388 54.426319,86.083893 
                C47.005894,87.588989 39.908096,87.073746 32.421631,84.775581 
            M56.558495,23.762247 
                C49.372227,19.989401 42.513557,19.830839 35.252708,24.223000 
                C26.643309,29.430908 21.597399,35.992546 21.828566,46.591488 
                C22.216236,64.366005 40.532032,75.944527 56.115879,67.928802 
                C63.749046,64.002602 69.123024,58.496494 70.071312,49.537800 
                C71.262268,38.286415 66.597702,30.032303 56.558495,23.762247 
            z"/>
            <path fill="#E50CAB" opacity="1.000000" stroke="none" 
                d="
            M56.878036,23.965351 
                C66.597702,30.032303 71.262268,38.286415 70.071312,49.537800 
                C69.123024,58.496494 63.749046,64.002602 56.115879,67.928802 
                C40.532032,75.944527 22.216236,64.366005 21.828566,46.591488 
                C21.597399,35.992546 26.643309,29.430908 35.252708,24.223000 
                C42.513557,19.830839 49.372227,19.989401 56.878036,23.965351 
            M46.419510,26.024519 
                C43.084671,27.095646 39.512199,27.714155 36.457111,29.318123 
                C24.726568,35.476845 22.528772,51.167244 31.902210,60.337551 
                C37.214001,65.534225 46.249851,67.478905 52.334431,64.854584 
                C61.912151,60.723648 66.933914,51.551716 65.839531,44.859680 
                C64.232063,35.030174 59.770256,28.721136 46.419510,26.024519 
            z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
                d="
            M46.846802,26.024841 
                C59.770256,28.721136 64.232063,35.030174 65.839531,44.859680 
                C66.933914,51.551716 61.912151,60.723648 52.334431,64.854584 
                C46.249851,67.478905 37.214001,65.534225 31.902210,60.337551 
                C22.528772,51.167244 24.726568,35.476845 36.457111,29.318123 
                C39.512199,27.714155 43.084671,27.095646 46.846802,26.024841 
            M42.537727,37.910957 
                C42.023155,38.156925 41.063824,38.395496 41.059589,38.649960 
                C40.972408,43.889763 40.994007,49.131374 40.994007,55.258652 
                C45.891918,51.947502 50.073635,49.120522 54.639263,46.034004 
                C50.427765,43.075813 46.856060,40.567013 42.537727,37.910957 
            z"/>
            <path fill="#E509AA" opacity="1.000000" stroke="none" 
                d="
            M42.911041,37.984589 
                C46.856060,40.567013 50.427765,43.075813 54.639263,46.034004 
                C50.073635,49.120522 45.891918,51.947502 40.994007,55.258652 
                C40.994007,49.131374 40.972408,43.889763 41.059589,38.649960 
                C41.063824,38.395496 42.023155,38.156925 42.911041,37.984589 
            z"/>
        </svg>
	);
};
